import { PolymorphicComponentPropWithRef } from "@omni/types/components/utils/polymorphic.types";
import { cn } from "@omni/utils/styles";
import React from "react";

export type TdComponentProps = {};

export type TdProps<T extends React.ElementType> =
    PolymorphicComponentPropWithRef<T, TdComponentProps, "td">;

const Td = <T extends React.ElementType = "td">({
    ref,
    className,
    tag,
    innerRef: _innerRef,
    children,
    ...attributes
}: TdProps<T>) => {
    const Tag = tag || ("td" as React.ElementType);

    const classes = cn(
        "tw:p-3 tw:border-border tw:border-t tw:align-top",
        className
    );

    const table = (
        <Tag
            {...attributes}
            ref={ref}
            className={classes}
        >
            {children}
        </Tag>
    );

    return table;
};

export { Td };
